import cookies from '@/utils/cookies';
import { computed } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { pageview } from 'vue-gtag';
import userStore from '../store/user';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from) {
    if (to.hash) {
      return { el: to.hash };
    }

    const { meta: metaTo } = to;
    const { meta: metaFrom } = from;

    if (metaTo && metaFrom) {
      if (metaTo.disableScrollToTop && metaFrom.disableScrollToTop) return
    }

    document.getElementById('app').scrollIntoView();
  },

});

const isInternalURL = (urlString) => {
  const internalUrls = ['localhost'];

  try {
    return new RegExp(internalUrls.join('|')).test(new URL(urlString).hostname);
  } catch {
    return false;
  }
};

router.beforeEach((to, from, next) => {
  const { value: currentUser } = computed(() => userStore.state.currentUser);
  pageview(to.path)

  if (to.name === 'Home' && isInternalURL(from.query.redirect)) {
    window.location.assign(from.query.redirect);

    return;
  }

  if (from.query.redirect && !to.redirectedFrom) {
    next({
      // ...to,
      redirectedFrom: 'login',
      path: from.query.redirect,
      replace: true,
    });

    return;
  }

  const hasToken = !!cookies.getItem('token');

  if (to.name === 'Login' && hasToken) {
    next({ name: 'Home' });
  } else if (to.matched.some((record) => record.meta.allowAnonymous) || hasToken) {
    if (to.matched.some((record) => record.meta.isCompany)) {
      if (!currentUser.isCompany) {
        next({ name: 'Home' });
        return;
      }
    }
    next();
  } else if (to.matched.some((record) => record.meta.isCompany)) {
    if (!currentUser.isCompany) {
      next({ name: 'Home' });
    }
  } else if (to.fullPath) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  } else {
    next({ name: 'Login' })
  }
});

export default router;
